import {
  VaccineAdministeredModel,
  IVaccineAdministeredModel,
} from '@common/models/VaccineAdministeredModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class VaccineAdministeredService {
  private static baseUrl: string = '/api/vaccineadministered/';
  static tags = {
    upsertVaccineAdministered: 'upsertVaccineAdministered',
    deleteVaccineAdministered: 'deleteVaccineAdministered',
  };

  static upsertVaccineAdministered = (
    data: IVaccineAdministeredModel,
  ): Promise<VaccineAdministeredModel> => {
    return trackPromise(
      new Promise<VaccineAdministeredModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IVaccineAdministeredModel>(data)
          .then((response) => {
            resolve(new VaccineAdministeredModel(response));
          })
          .catch(reject);
      }),
      this.tags.upsertVaccineAdministered,
    );
  };

  static deleteVaccineAdministered = (
    vaccineAdministeredId: number,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}${vaccineAdministeredId}`)
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch(reject);
      }),
      this.tags.deleteVaccineAdministered,
    );
  };
}
